import cn from 'classnames';

import { useCheckoutContext, Article } from '@zooplus/checkout-state';
import { isBitiba } from '@zooplus/commons-lang';
import { Bin } from '@zooplus/icons';
import { P1, Anchor } from '@zooplus/ui-components';

import styles from '../cart-item.module.scss';
import ItemStandardPrice from '../item-standard-price';

import { getAppConfig } from '@config/get-app-config';
import SavingsPlan from '@public/images/savings-plan.svg';
import { CHECKOUT_STATE_PROJECT_ID, CART_ITEM_IMAGE_DIMENSION } from '@utilities/constants';
import { showFallbackImage } from '@utilities/fallback-image';

const SavingsPlanItem = ({ id, name, pictureUrl, formattedSubtotal }: Article) => {
  const { setSavingsPlanArticle, mainTogglesMap = {} } =
    useCheckoutContext(CHECKOUT_STATE_PROJECT_ID);

  const isNewPricingEnabled = mainTogglesMap.NEW_PRICING_COMPONENT_IN_CART_AND_PREVIEW;

  const handleChange = () => {
    setSavingsPlanArticle?.({
      articleId: id,
      quantity: 0,
      articleName: name,
    });
  };
  const { site } = getAppConfig();
  const { WIDTH, HEIGHT } = CART_ITEM_IMAGE_DIMENSION;

  return (
    <article className={cn(styles.productInfoWrapper, styles.typeFreeOrSPArticle)}>
      <section className={cn(styles.productImgWrapper, styles.imgSavingsPlanArticle)}>
        {isBitiba(site.domain) ? (
          <img
            loading="lazy"
            src={pictureUrl}
            alt={name}
            onError={(e) =>
              showFallbackImage(e, {
                width: WIDTH,
                height: HEIGHT,
              })
            }
          />
        ) : (
          <SavingsPlan />
        )}
      </section>
      <section data-testid="product-sp-info" className={styles.productNameWrapper}>
        <P1 bold data-testid="product-name" className={styles.productName}>
          {name}
        </P1>
      </section>
      <section className={styles.priceInfoSP}>
        <Anchor
          className={styles.removeSavingsPlan}
          data-testid="remove-sp-article-btn"
          onClick={() => handleChange()}>
          <Bin />
        </Anchor>
        <div>
          <ItemStandardPrice
            formattedSubtotal={formattedSubtotal}
            isNewPricingEnabled={isNewPricingEnabled}
          />
        </div>
      </section>
    </article>
  );
};

export default SavingsPlanItem;
